import {Component, Input, Output, EventEmitter, ViewChild, OnInit, OnChanges, SimpleChanges} from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {AuthService} from "../services/auth.service";
import {Observable} from "rxjs";
import {MicroSelectComponent} from "../shared/select/micro-select.component";
import {NG_VALUE_ACCESSOR} from "@angular/forms";

@Component({
  selector: 'micro-ussdSvcCode-select',
  templateUrl: './ussdSvcCode-select.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi:true,
      useExisting: UssdSvcCodeSelectComponent
    }
  ]
})
export class UssdSvcCodeSelectComponent implements OnInit, OnChanges {

  @ViewChild("sel", {static: true}) sel:MicroSelectComponent;

  @Input()
  mode:string = 'simple';

  @Output()
  ussdSvcCodeIdChange:EventEmitter<any> = new EventEmitter<any>();

  @Input()
  ussdSvcCodeId:any;

  @Output()
  valueChange:EventEmitter<any> = new EventEmitter<any>();

  @Input()
  value:any = '';

  @Input()
  required:boolean = false;

  @Input()
  disabled:boolean = false;

  options:any[];

  valueCallback(option) {
    if (option.hosted) {
      return `${option.svcCode} (Hosted)`;
    }
    return option.svcCode;
  }

  onChange = (id) => {};
  onTouched = () => {};
  touched = false;

  change(e) {
    this.onChange(e);
    this.ussdSvcCodeIdChange.emit(e);
    this.valueChange.emit(this.sel.getSelectedValue());
  }

  constructor(private auth:AuthService, private env:EnvService, private http:HttpClient) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    for (let prop in changes) {
      if (prop === 'webClientGroupId') {
        this.reload();
      }
    }
  }

  registerOnChange(onChange: any): void {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  writeValue(id: string): void {
    this.ussdSvcCodeId = id;
  }

  reload() {
    let params:HttpParams = new HttpParams();
    return this.http.get(`${this.env.e.url}/ussd/ussdSvcCodes/all`, {params:params})
      .subscribe(data => {
        this.options = data as any[];
        this.sel.loading = false;
      });
  }

  ngOnInit(): void {
    this.reload();
  }
}
